const parameterize = (string: string, separator = '-') => {
  if (!string) return '';

  return string.toLowerCase().replace(/[^a-z0-9\-_]+/gi, separator);
};

export default parameterize;
